// @format
//
// LinkedIn message composer — mirrors init_email_composer_button_listeners.
// Opens #linkedinComposerModal from a .linkedin-composer-button and sends the
// message via linkedin_message_histories#send_message.

import { showNotice } from "../../notice";

export function initLinkedinComposerListeners(): void {
  $(document).off("click", ".linkedin-composer-button").on("click", ".linkedin-composer-button", function () {
    const $button = $(this);
    const modal = $("#linkedinComposerModal");
    modal.data("unipile-request-id", $button.data("bots-prospect-unipile-request-id"));
    modal.find("#linkedinRecipient").val($button.data("prospect-name") || "");
    modal.find("#linkedinMessageText").val("");
    modal.modal("show");
  });

  $("#linkedinComposerModal").on("shown.bs.modal", function () {
    $(this).off("click", "#sendLinkedinMessageBtn").on("click", "#sendLinkedinMessageBtn", function (e) {
      e.preventDefault();
      const form = document.getElementById("linkedinMessageForm") as HTMLFormElement;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const modal = $("#linkedinComposerModal");
      const $button = $(this);
      const requestId = modal.data("unipile-request-id");
      const text = modal.find("#linkedinMessageText").val();

      $button.prop("disabled", true).val("Sending...");
      $.ajax({
        url: "/linkedin_message_histories/send_message",
        method: "POST",
        data: { bots_prospect_unipile_request_id: requestId, text: text },
        success: function () {
          $button.prop("disabled", false).val("Send Message");
          modal.find("#linkedinMessageText").val("");
          modal.modal("hide");
          showNotice("LinkedIn message sent successfully.", "success");
        },
        error: function (xhr) {
          const msg = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : "Message could not be sent.";
          $button.prop("disabled", false).val("Send Message");
          showNotice(msg, "danger");
        },
      });
    });
  });

  $("#linkedinComposerModal").on("hidden.bs.modal", function () {
    $(this).find("#linkedinMessageText").val("");
  });
}
